module.exports = __webpack_public_path__ + "img/header_fallback.e2267363.png";